import React from "react";

const Services = () => {
  return (
    <section id="services" className="py-20 bg-muted">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl font-bold text-foreground text-center mb-16 animate-fadeIn">
          Our Services
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Card 1 */}
          <div className="bg-background p-8 rounded-lg shadow-md border border-border transform transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-black/30 animate-slideUp">
            <img
              src="/assets/hill.jpeg"
              alt="Residential Construction"
              className="w-full h-48.1 object-cover rounded-lg mb-6"
            />
            <h3 className="text-xl font-semibold text-foreground mb-4">
              Residential Construction
            </h3>
            <p className="text-muted-foreground">
              Custom home building from foundation to finish, ensuring quality
              craftsmanship and attention to detail.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-background p-8 rounded-lg shadow-md border border-border transform transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-black/30 animate-slideUp delay-200">
            <img
              src="/assets/interior.jpeg"
              alt="Interior Design"
              className="w-full h-51.3 object-cover rounded-lg mb-6"
            />
            <h3 className="text-xl font-semibold text-foreground mb-4">
              Interior Design
            </h3>
            <p className="text-muted-foreground">
              Creating beautiful, functional spaces that reflect your personal
              style and enhance your living experience.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-background p-8 rounded-lg shadow-md border border-border transform transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-black/30 animate-slideUp delay-400">
            <img
              src="/assets/reno.jpeg"
              alt="Home Renovation"
              className="w-full h-51 object-cover rounded-lg mb-6"
            />
            <h3 className="text-xl font-semibold text-foreground mb-4">
              Home Renovation
            </h3>
            <p className="text-muted-foreground">
              Transforming existing spaces with modern updates while preserving
              the character of your home.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
